module.exports = __webpack_public_path__ + "media/mfg/training-d34ace48.jpg";